/**
 * Constants for Notepad/Tasks feature
 */

/**
 * Default reminder time (9:00 AM)
 */
export const DEFAULT_REMINDER_HOUR = 9;
export const DEFAULT_REMINDER_MINUTE = 0;

/**
 * Maximum number of tasks to load at once
 */
export const MAX_TASKS_LIMIT = 100;

/**
 * Maximum number of notes to load at once
 */
export const MAX_NOTES_LIMIT = 100;

/**
 * Toast duration for undo actions (milliseconds)
 */
export const UNDO_TOAST_DURATION = 5000;

/**
 * Snooze presets (minutes)
 */
export const SNOOZE_PRESETS = {
  SHORT: 15,
  MEDIUM: 60,
  LONG: 180,
} as const;

/**
 * Reminder presets (minutes)
 */
export const REMINDER_PRESETS = {
  SHORT: 15,
  MEDIUM: 60,
  LONG: 180,
} as const;
